import { useEffect, forwardRef, useImperativeHandle } from 'react';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import Emitter from '@/helpers/emitter.js';
import cookie from '@/helpers/cookie';

const StartTourEvents = forwardRef(({ maxTour }, ref) => {
  const isTour = useSearchZustandStore((state) => state.isTour);

  function runStartTour() {
    if (isTour) Emitter.emit('emit_start_order_index_1');
  }

  useImperativeHandle(ref, () => ({
    runStartTour,
  }));

  function nextEvent(currentEvent) {
    if (isTour) {
      let curEvent = currentEvent;
      curEvent += 1;
      Emitter.emit(`emit_start_order_index_${curEvent}`);
      if (curEvent > maxTour) useSearchZustandStore.setState({ isTour: false });
    }
  }
  function stopTour() {
    if (isTour) {
      cookie.set('isTourCookie', 'false', {
        maxAge: 7 * 24 * 60 * 60,
      });
      useSearchZustandStore.setState({ isTour: false });
    }
    Emitter.off('emit_done_index', nextEvent);
  }

  useEffect(() => {
    Emitter.on('emit_done_index', nextEvent);
    Emitter.on('emit_done_tour', stopTour);
    return () => {
      Emitter.off('emit_done_index', nextEvent);
      Emitter.off('emit_done_tour', stopTour);
    };
  }, [isTour]);

  return null;
});

export default StartTourEvents;
